import { supabase } from "@/integrations/supabase/client";
import { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database/base";

/**
 * Strongly typed Supabase client with enhanced type safety
 * Use this instead of the raw supabase client for complete type coverage
 */
export const typedSupabase = supabase as unknown as SupabaseClient<Database>;

/**
 * Utility types for easier imports
 */
export type TableRow<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Row"];

export type TableInsert<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Insert"];

export type TableUpdate<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Update"];

export type ViewRow<T extends keyof Database["public"]["Views"]> =
  Database["public"]["Views"][T]["Row"];

export type DatabaseEnum<T extends keyof Database["public"]["Enums"]> =
  Database["public"]["Enums"][T];

export type FunctionReturn<T extends keyof Database["public"]["Functions"]> =
  Database["public"]["Functions"][T]["Returns"];

// Re-export the original client for edge cases
export { supabase as originalSupabase } from "@/integrations/supabase/client";

